import SETTINGS from './settings';

const init = config => {
  Object.keys(SETTINGS).forEach(key => {
    if (config[key]) {
      SETTINGS[key] = config[key];
    }
  });
};

export default init;
